import { D2CRefundPolicyRuleCriterion, D2CRefundPolicyRuleRefundChargeUnit, D2CRefundPolicyRuleTimeUnit, } from '../enums';
export const getD2CRefundPolicyRuleText = (rule) => {
    let text = '';
    switch (rule.criterion) {
        case D2CRefundPolicyRuleCriterion.CREATED_AT:
            text = '예약일';
            break;
        case D2CRefundPolicyRuleCriterion.PICK_UP_AT:
            text = '대여일';
            break;
        default:
            break;
    }
    text += ' 기준';
    text += ` ${rule.timeValue}`;
    switch (rule.timeUnit) {
        case D2CRefundPolicyRuleTimeUnit.HOURS:
            text += '시간';
            break;
        case D2CRefundPolicyRuleTimeUnit.DAYS:
            text += '일';
            break;
        default:
            break;
    }
    if (rule.criterion === D2CRefundPolicyRuleCriterion.PICK_UP_AT &&
        rule.timeValue === 0) {
        text = '당일 취소(NOSHOW)';
    }
    switch (rule.criterion) {
        case D2CRefundPolicyRuleCriterion.CREATED_AT:
            text += ' 이내';
            break;
        case D2CRefundPolicyRuleCriterion.PICK_UP_AT:
            text += ' 이전';
            break;
        default:
            break;
    }
    text += ' 취소 시';
    if (rule.refundChargeUnit === D2CRefundPolicyRuleRefundChargeUnit.PERCENT) {
        if (rule.refundChargeValue === 0) {
            text += ' 전액 환불';
            return text;
        }
        else if (rule.refundChargeValue === 100) {
            text += ' 전액 환불 불가';
            return text;
        }
    }
    switch (rule.refundChargeUnit) {
        case D2CRefundPolicyRuleRefundChargeUnit.PERCENT:
            text += ` ${rule.refundChargeValue}% 수수료 발생`;
            break;
        case D2CRefundPolicyRuleRefundChargeUnit.AMOUNT:
            text += ` ${rule.refundChargeValue}원 수수료 발생`;
            break;
        default:
            break;
    }
    return text;
};
